import React from 'react';
import { ListColumn, FooterOptions } from '../Datalist/Datalist'; // Import your Datalist component
import Datalist from '../Datalist/Datalist';
import './MemberInvoiceTable.scss';
import { useNavigate } from 'react-router-dom';
import { format } from 'date-fns'; // Import format from date-fns
import { IMemberInvoiceReviewItem } from '../../data/API/MemberInvoiceReview';

interface MemberInvoiceTableProps {
    invoiceData: IMemberInvoiceReviewItem[];
    isLoading: boolean;
}

const MemberInvoiceTable: React.FC<MemberInvoiceTableProps> = ({ invoiceData, isLoading }) => {

    const navigate = useNavigate(); // Use the navigate hook for navigation

    // Define the columns for the Invoice table
    const columns: ListColumn<IMemberInvoiceReviewItem>[] = React.useMemo(() => [
        {
            key: 'invoiceNumber',
            fieldName: 'invoiceNumber',
            name: 'Fakturanr',
            minWidth: 150,
            isActive: true,
            sorting: true, // Enable sorting
            onRender: (item: IMemberInvoiceReviewItem) => item.invoiceNumber,
            footer: (items: IMemberInvoiceReviewItem[]) => `Antal: ${items.length}`,
        },
        {
            key: 'contractId',
            fieldName: 'contractId',
            name: 'Avtal',
            minWidth: 150,
            isActive: true,
            sorting: true, // Enable sorting
            onRender: (item: IMemberInvoiceReviewItem) => item.contractId,
        },
        {
            key: 'billingDate',
            fieldName: 'billingDate',
            name: 'Datum',
            minWidth: 150,
            isActive: true,
            sorting: true, // Enable sorting
            onRender: (item: IMemberInvoiceReviewItem) => format(new Date(item.billingDate), 'yyyy-MM-dd'), // Format date using date-fns
        },
        {
            key: 'priceExcMoms',
            fieldName: 'priceExcMoms',
            name: 'Belopp (Ex. Moms)',
            minWidth: 150,
            isActive: true,
            sorting: true, // Enable sorting
            onRender: (item: IMemberInvoiceReviewItem) => {
                const formattedPrice = new Intl.NumberFormat('sv-SE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(item.priceExcMoms);
                return `${formattedPrice} SEK`;
            },
            footer: (items: IMemberInvoiceReviewItem[]) => {
                const total = items.reduce((sum, row) => sum + row.priceExcMoms, 0);
                const formattedTotal = new Intl.NumberFormat('sv-SE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(total);
                return `Total: ${formattedTotal} SEK`;
            }
        },
        {
            key: 'priceIncMoms',
            fieldName: 'priceIncMoms',
            name: 'Belopp (In. Moms)',
            minWidth: 150,
            isActive: true,
            sorting: true, // Enable sorting
            onRender: (item: IMemberInvoiceReviewItem) => {
                const formattedPrice = new Intl.NumberFormat('sv-SE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(item.priceIncMoms);
                return `${formattedPrice} SEK`;
            },
            footer: (items: IMemberInvoiceReviewItem[]) => {
                const total = items.reduce((sum, row) => sum + row.priceIncMoms, 0);
                const formattedTotal = new Intl.NumberFormat('sv-SE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(total);
                return `Total: ${formattedTotal} SEK`;
            }
        }
    ], [invoiceData]);

    return (
        <div className="customer-table-wrapper" style={{ maxHeight: '600px', overflowY: 'auto', marginTop: '10px' }}>
            {/* Use the Datalist component */}
            <Datalist
                items={invoiceData}
                isLoading={isLoading}
                columns={columns}
                setColumns={(updatedColumns: ListColumn<IMemberInvoiceReviewItem>[]) => {}}
                initialSortKey="billingDate"  // Set default sort column
                descendingSort={true}    // Set default sort order to descending (most recent first)
                noItemsText="Inga fakturor tillgängliga"
                uniqueKey="invoiceNumber"  // Use 'invoiceNumber' as the unique key
            />
        </div>
    );
};

export default MemberInvoiceTable;
